<template>
   <div style="width: 100%; height: 100%;">
      <div class="custom-container">
         <v-row no-gutters justify="center">
            <v-col cols="12" md="8">
               <v-card flat>
                  <v-card-title class="headline">
                     Kategorie Ansicht
                  </v-card-title>
               </v-card>
               <v-card>
                  <v-card-title class="headline" style="word-break: normal;">
                     {{ category.name }}
                     <v-tooltip bottom v-if="$can('store ideasCategory')">
                        <template v-slot:activator="{ on, attrs }">
                           <v-btn
                              color="primary"
                              v-bind="attrs"
                              v-on="on"
                              icon
                              :to="{name: 'IdeasWorkbenchCategoriesEdit', params: {id: category.id}}"
                           >
                              <v-icon color="primary" class="ma-0">mdi-circle-edit-outline</v-icon>
                           </v-btn>
                        </template>
                        <span>Kategorie bearbeiten</span>
                     </v-tooltip>
                     <v-tooltip bottom v-if="$can('store ideasCategory')">
                        <template v-slot:activator="{ on, attrs }">
                           <v-btn
                              color="primary"
                              v-bind="attrs"
                              v-on="on"
                              icon
                              @click.prevent="destroyCategory"
                           >
                              <v-icon color="error" class="ma-0">mdi-delete</v-icon>
                           </v-btn>
                        </template>
                        <span>Kategorie löschen</span>
                     </v-tooltip>
                     <v-spacer/>
                     <v-btn :to="{ name: 'IdeasWorkbenchIdeasCreate', query: { id: category.id}}" color="secondary"
                            depressed>Neue Idee
                     </v-btn>
                  </v-card-title>
                  <v-card-text>
                     {{ category.description }}
                  </v-card-text>
               </v-card>
               <div class="mt-8">
                  <v-tabs center-active centered show-arrows>
                     <v-tab>
                        Alle
                     </v-tab>
                     <v-tab>
                        <v-icon small color="success" class="mr-2">
                           mdi-checkbox-blank-circle-outline
                        </v-icon>
                        Offen
                     </v-tab>
                     <v-tab>
                        <v-icon small color="info" class="mr-2">
                           mdi-clock-outline
                        </v-icon>
                        In Bearbeitung
                     </v-tab>
                     <v-tab>
                        <v-icon small color="warning" class="mr-2">
                           mdi-close-circle-outline
                        </v-icon>
                        Nicht umsetzbar
                     </v-tab>
                     <v-tab>
                        <v-icon small color="success" class="mr-2">
                           mdi-arrow-top-right-thin-circle-outline
                        </v-icon>
                        In Umsetzung
                     </v-tab>
                     <v-tab>
                        <v-icon small color="success darken-1" class="mr-2">
                           mdi-check-circle-outline
                        </v-icon>
                        Umgesetzt
                     </v-tab>
                     <v-tab>
                        <v-icon small color="error" class="mr-2">
                           mdi-checkbox-blank-circle
                        </v-icon>
                        Geschlossen
                     </v-tab>

                     <v-tab-item>
                        <IdeasWorkbenchCategoriesShowIdeasList :ideas="category.ideas"/>
                     </v-tab-item>
                     <v-tab-item>
                        <IdeasWorkbenchCategoriesShowIdeasList :ideas="category.ideas_open"/>
                     </v-tab-item>
                     <v-tab-item>
                        <IdeasWorkbenchCategoriesShowIdeasList :ideas="category.ideas_review"/>
                     </v-tab-item>
                     <v-tab-item>
                        <IdeasWorkbenchCategoriesShowIdeasList :ideas="category.ideas_declined"/>
                     </v-tab-item>
                     <v-tab-item>
                        <IdeasWorkbenchCategoriesShowIdeasList :ideas="category.ideas_accepted"/>
                     </v-tab-item>
                     <v-tab-item>
                        <IdeasWorkbenchCategoriesShowIdeasList :ideas="category.ideas_realized"/>
                     </v-tab-item>
                     <v-tab-item>
                        <IdeasWorkbenchCategoriesShowIdeasList :ideas="category.ideas_closed"/>
                     </v-tab-item>
                  </v-tabs>
               </div>
            </v-col>
         </v-row>
      </div>
   </div>
</template>

<script>
import {mapActions} from 'vuex';

export default {
   props: [],
   name: "",
   data: () => ({
      category: {
         ideas: {},
      },
   }),
   created() {
      if (this.$route.params.id) {
         this.getCategory();
      }

   },
   methods: {
      ...mapActions({}),
      getCategory() {
         this.axios.get('/ideas-categories/' + this.$route.params.id).then((r) => {
            this.category = r.data.data;
         })
      },

      subscribeFeed(id) {
         var data = {};
         data.feedable_type = 'idea';
         data.feedable_id = id;

         this.axios.post('/feeds', {
            'feed': data
         }).then(() => {
            this.$toast.success('Sie erhalten nun Benachrichtigungen der Idee.');
            this.getCategory();
         })
      },

      unsubscribeFeed(id) {
         this.axios.delete('/feeds/' + id).then(() => {
            this.$toast.success('Sie erhalten nun keine Benachrichtigungen der mehr.');
            this.getCategory();
         })
      },

      vote(value, id) {
         this.axios.post('/ideas/' + id + '/vote', {
            'value': value
         }).then(() => {
            this.$toast.success('Der Vote wurde erfolgreich platziert.');
            this.getCategory();
         }).catch((e) => {
            console.log(e);
            this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
         })
      },
      color(vote, positive) {
         if (vote === 1 && positive) {
            return 'green darken-2';
         } else if (vote === -1 && !positive) {
            return 'red';
         } else {
            return 'grey lighten-1';
         }
      },
      destroyCategory(){
         this.axios.delete('/ideas-categories/' + this.$route.params.id).then(() => {
            this.$toast.success('Die Kategorie wurde erfolgreich gelöscht.');
            this.$router.push({name: 'IdeasWorkbenchDashboard'});
         }).catch(() => {
            this.$toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
         })
      }
   },
}
</script>

<style scoped>

</style>
